import { useUntypedModalContext } from 'react-easyrocket';
import { ModalMapKeys } from 'src/constants/modals';

export const useModalContext = <ModalPropsType>() =>
  useUntypedModalContext<ModalMapKeys, ModalPropsType>();
